import PropTypes from "prop-types";

const IconButtonBase = ({
  title = "Title",
  icon,
  size = "small",
  className = "",
  ...props
}) => {
  const sizeClasses = {
    small: "p-1 text-sm",
    medium: "p-2 text-base",
    large: "p-3 text-lg",
  };

  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center rounded-full hover:bg-gray-200 transition duration-150 ease-in-out ${sizeClasses[size]} ${className}`}
      title={title}
      {...props}
    >
      {icon}
    </button>
  );
};

IconButtonBase.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: PropTypes.string,
};

export default IconButtonBase;

